import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import '../styles/style1.css';
import { DatePicker, Select } from "antd";
import dayjs from "dayjs";
import ListAllCars from "../components/List/ListAllCars";
import { ENDPOINT } from "../Services/ENDPOINT";

const SelectCarPage = () => {
  const location = useLocation();

  const [data, setData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [returnDate, setReturnDate] = useState();
  const [totalDay, setTotalDay] = useState(null);
  const [droptype, setDroptype] = useState(null);

  const redirectData = location.state?.data;

  useEffect(() => {
    console.log("Redirect data:", redirectData);
    setData(redirectData);
  }, [redirectData]);

  // 24 hr consider as 1 day
  // ✅ Accept selectedReturnDate as a parameter to avoid stale state
  // const calculateTotalDays = (pickupDate, pickupTime, selectedReturnDate) => {
  //   const effectiveReturnDate = selectedReturnDate ?? returnDate;

  //   if (!pickupDate || !effectiveReturnDate) {
  //     setTotalDay(0);
  //     return;
  //   }

  //   const pickupDateTime = pickupTime
  //     ? dayjs(`${pickupDate} ${pickupTime}`)
  //     : dayjs(pickupDate);

  //   if (!pickupDateTime.isValid() || !effectiveReturnDate.isValid()) {
  //     setTotalDay(0);
  //     return;
  //   }

  //   const diffDays = effectiveReturnDate.startOf("day").diff(
  //     pickupDateTime.startOf("day"),
  //     "day"
  //   );

  //   // SAME DAY or earlier → 0
  //   if (diffDays <= 0) {
  //     setTotalDay(0);
  //   } else {
  //     setTotalDay(diffDays);
  //   }
  // };

  const calculateTotalDays = (pickupDate, pickupTime, selectedReturnDate) => {
    const effectiveReturnDate = selectedReturnDate ?? returnDate;

    if (!pickupDate || !effectiveReturnDate) {
      setTotalDay(0);
      return;
    }

    const pickupDateTime = pickupTime
      ? dayjs(`${pickupDate} ${pickupTime}`)
      : dayjs(pickupDate);

    if (!pickupDateTime.isValid() || !effectiveReturnDate.isValid()) {
      setTotalDay(0);
      return;
    }

    const diffDays = effectiveReturnDate
      .startOf("day")
      .diff(pickupDateTime.startOf("day"), "day");

    if (diffDays < 0) {
      setTotalDay(0);
    } else {
      setTotalDay(diffDays + 1); // ✅ Inclusive counting
    }
  };

  const getUrlData = async () => {
    try {
      // Step 1: Get parent_url from query
      const params = new URLSearchParams(location.search);
      const parentUrl = params.get("parent_url");

      if (!parentUrl) return;

      // Step 2: Parse parent_url
      const urlObj = new URL(parentUrl);
      const p = new URLSearchParams(urlObj.search);

      const finalData = {
        type: p.get("type") || "",

        tripType:
          p.get("trip_type") ||
          p.get("o_trip_type") ||
          "",

        rental_duration: p.get("duration") || "",

        from:
          p.get("from") ||
          p.get("o_from") ||
          "",

        to:
          p.get("to") ||
          p.get("o_to") ||
          "",

        pickup_date:
          p.get("pickup_date") ||
          p.get("o_pickup_date") ||
          "",

        pickup_time:
          p.get("pickup_time") ||
          p.get("o_pickup_time") ||
          "",

        o_ot_type: p.get("o_ot_type") || "",

        pickup_at:
          p.get("pickup_at") ||
          p.get("o_pickup_at") ||
          "",

        o_return_date:
          p.get("o_return_date") ||
          "",

        total_distance:
          p.get("total_distance_km") ||
          p.get("o_total_distance_km") ||
          "",

        one_way_distance:
          p.get("one_way_distance_km") ||
          p.get("o_one_way_distance_km") ||
          "",
      };

      console.log("🚀 FULL PARENT URL:", parentUrl);
      console.log("✅ FINAL DATA:", finalData);

      setData(finalData);
      setDroptype(finalData.o_ot_type);

      console.log("finalData.o_ot_type", finalData.o_ot_type);

      // ✅ Parse the return date and immediately calculate totalDay using it directly
      const parsedReturnDate = finalData.o_return_date
        ? dayjs(finalData.o_return_date)
        : null;

      setReturnDate(parsedReturnDate);

      // ✅ Pass parsedReturnDate directly so we don't rely on stale state
      if (parsedReturnDate) {
        calculateTotalDays(
          finalData.pickup_date,
          finalData.pickup_time,
          parsedReturnDate
        );
      }

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUrlData();
  }, [location.search]);

  useEffect(() => {
    // window.location.reload();
  }, []);

  return (
    <>
      {data?.type !== "rental" && (
        <div className="w3l-blog-block-12 pt-5">
          <div className="container py-md-5 pt-4">
            <div className="details-wrapper">
              <div className="details-grid-box">

                <div className="detail-card">
                  {/* <div
                    className="edit-action"
                    onClick={() => {
                      window.top.location.href = ENDPOINT.client_url;
                    }}
                  >
                    <i className="fas fa-edit"></i>
                    <span>Edit</span>
                  </div> */}

                  <span className="detail-value">
                    <span className="detail-title">{data?.tripType} Trip</span>
                  </span>

                  <span className="detail-value">
                    {data?.from} - {data?.to}
                  </span>
                </div>

                <div className="detail-card">
                  {/* <div
                    className="edit-action"
                    onClick={() => {
                      window.top.location.href = "https://hemacabs.com/";
                    }}
                  >
                    <i className="fas fa-edit"></i>
                    <span>Edit</span>
                  </div> */}

                  <span className="detail-value">{data?.pickup_date}</span>
                  <span className="detail-value">{data?.pickup_time}</span>
                  <span className="detail-title">Pickup Date & Time</span>
                </div>

                {/* date picker */}
                {data?.type === "outstation" && data?.tripType === "round" && (
                  <div className="detail-card">
                    <div
                      className="edit-action"
                      onClick={() => setIsDatePickerOpen(true)}
                    >
                      <i className="fas fa-edit"></i>
                      <span>Edit</span>
                    </div>

                    <span className="detail-title">Return Date</span>

                    <DatePicker
                      size="large"
                      open={isDatePickerOpen}
                      value={returnDate}
                      onChange={(date) => {
                        setReturnDate(date);
                        setIsDatePickerOpen(false);

                        // ✅ Pass date directly to avoid stale state
                        calculateTotalDays(
                          data?.pickup_date,
                          data?.pickup_time,
                          date
                        );
                      }}
                      onOpenChange={(open) => setIsDatePickerOpen(open)}
                      disabledDate={(current) => {
                        if (!data?.pickup_date) return false;

                        const pickupDate = dayjs(data.pickup_date).startOf("day");
                        return current && current.startOf("day").isBefore(pickupDate);
                      }}
                      defaultPickerValue={
                        data?.pickup_date ? dayjs(data.pickup_date) : dayjs()
                      }
                      style={{ marginTop: 8 }}
                    />

                  </div>
                )}

                {data?.type === "outstation" &&
                  (data?.o_ot_type === "regular" || data?.o_ot_type === "premium") && (

                    <div className="detail-card">


                      <span className="detail-title">Drop Type</span>

                      <Select
                        size="large"
                        // mode="multiple"
                        value={droptype}
                        placeholder="Select drop type"
                        
                        onChange={(value) => {
                          setDroptype(value)
                        }}
                      >
                        <Select.Option value="premium">Premium Drop</Select.Option>
                        <Select.Option value="regular">Regular Drop</Select.Option>

                      </Select>


                    </div>
                  )}

              </div>
            </div>
          </div>
        </div>
      )}

      {/* {data?.total_distance > 0 && (
        <div className="distance-info" style={{ marginTop: '20px' }}>
          <i className="fas fa-route fa-lg"></i>
          <strong>
            Total Distance: {Number(data?.total_distance).toFixed(2)} KM
          </strong>
        </div>
      )} */}

      <div style={{ marginTop: '20px' }}>
        <ListAllCars
          total_distance={Number(data?.total_distance).toFixed(2)}
          data={data}
          totalDay={totalDay}
          droptype={droptype} />
      </div>

    </>
  );
};

export default SelectCarPage;